var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobileLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.045,
    height: 29.51,
    viewBox: "0 0 27.045 29.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1290",
    "data-name": "Group 1290",
    transform: "translate(-25.388 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1083",
    "data-name": "Path 1083",
    d: "M1030.927,679.476a2.274,2.274,0,0,0,1.58,2.323,2.32,2.32,0,0,0,2.767-.655l22.026-24.463a2.457,2.457,0,0,0,.661-1.811,2.548,2.548,0,0,0-2.638-2.375,2.445,2.445,0,0,0-1.732.847l-17.678,19.634,0-8.423a2.5,2.5,0,0,0-2.506-2.485,2.321,2.321,0,0,0-1.756.722,2.459,2.459,0,0,0-.735,1.779Z",
    transform: "translate(-1005.532 -652.491)",
    fill: "#4af3f8",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileLogo);
export default __webpack_public_path__ + "static/media/mobileLogo.66abc6d7a388089e52d0a13fec8ac7cc.svg";
export { ForwardRef as ReactComponent };